module.exports = __webpack_public_path__ + "img/map2.401c7ba6.png";